/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const selectLocations = (state: { locations: any }) => state.locations.locations;
export const selectLocationsLoading = (state: { locations: any }) => state.locations.loading;
export const selectPaginationDetails = (state: { locations: any }) => state.locations.page;
export const selectLocationsError = (state: { locations: any }) => state.locations.error;
